import { render, staticRenderFns } from "./barFollow.vue?vue&type=template&id=c25b38b2&scoped=true"
import script from "./barFollow.vue?vue&type=script&lang=js"
export * from "./barFollow.vue?vue&type=script&lang=js"
import style0 from "./barFollow.vue?vue&type=style&index=0&id=c25b38b2&prod&lang=scss&scoped=true"
import style1 from "./barFollow.vue?vue&type=style&index=1&id=c25b38b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25b38b2",
  null
  
)

export default component.exports